import { Components, Theme } from '@mui/material';

export const tooltipOverrides: Components<Theme>['MuiTooltip'] = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      fontFamily: 'DM Sans',
      color: theme.palette.text.primary,
      padding: '8px 12px',
      fontSize: '12px',
      background: '#081116',
      borderRadius: '6px',
      fontWeight: 400,
    }),
  },
};
